import { useEffect, useState } from "react";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

// Estilos
import "./SearchInput.css";

/* 
    Componente de boton flotante de lupa que funciona para filtrar por busqueda.
        Donde buscar es la función que llama para filtrar por lo ingresado por el usuario.
*/
function SearchInput({ defaultValue, buscar }) {
  const [expanded, setExpanded] = useState(false);
  const [inputValue, setInputValue] = useState(defaultValue);

  useEffect(() => {
    // Si el valor por defecto no está vacío, expandimos la barra de búsqueda
    if (defaultValue !== "" && defaultValue !== undefined) {
      setExpanded(true);
      setInputValue(defaultValue);
    }
  }, [defaultValue]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    buscar(value);
  };

  const handleBlur = () => {
    // Solo contrae si el campo está vacío
    if (inputValue.trim() === "") {
      setExpanded(false);
    }
  };

  const handleMouseEnter = () => {
    if (defaultValue === "") {
      setExpanded(false); // Solo contrae si defaultValue está vacío
    }
  };

  const handleFocus = () => {
    setExpanded(true); // Expande la barra de búsqueda al hacer clic o enfocar
  };

  return (
    <div
      className={`search-container add-search ${expanded ? "expanded" : ""}`}
      onMouseEnter={handleMouseEnter}
      onFocus={handleFocus}
    >
      <FontAwesomeIcon icon={faMagnifyingGlass} className="add-search-cont" />
      <input
        placeholder="Buscar..."
        className="input-search-txt"
        value={defaultValue}
        onChange={handleInputChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </div>
  );
}

export default SearchInput;